export default __webpack_public_path__ + "static/media/A23.315a665f.png";